var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNgfConePenetrationTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.26,10.714c1.076-1.139,1.74-2.67,1.74-4.356,0-3.506-2.852-6.357-6.357-6.357s-6.357,2.852-6.357,6.357c0,1.686.665,3.217,1.74,4.356h-2.432l7.049,12.815,7.048-12.815h-2.432ZM11.643,2c2.402,0,4.357,1.955,4.357,4.357H7.286c0-2.402,1.955-4.357,4.357-4.357Zm0,17.379l-3.666-6.665h7.332l-3.666,6.665Z",
    fill: "#1c1c1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgfConePenetrationTest);
export default __webpack_public_path__ + "static/media/icon-ngf-cone-penetration-test.b6e7ac7901a1ba975b4d31611ec48e4a.svg";
export { ForwardRef as ReactComponent };